import { CreateService, CRUDServiceInterface } from '@/services/service';
import { BulletinCommentEntity } from '@/entities/bulletin-comment.entity';
import APIBuilder from '@quangphuc/frontend-api-builder';

export default class BulletinCommentService
  extends CreateService<BulletinCommentEntity>('bulletin-comment')
  implements CRUDServiceInterface<BulletinCommentEntity>
{
  async getOne(
    id: number,
    join: string[] = ['staff'],
  ): Promise<BulletinCommentEntity> {
    this.apiBuilder.reset()
    return super.getOne(id, join);
  }
  async upload(id: number, instance: { file: File }): Promise<void> {
    if (!instance.file) return;
    const formData = new FormData();
    if (instance.file) {
      formData.append('file', instance.file);
    }
    await APIBuilder.axios.patch<BulletinCommentEntity>(
      `${this.apiBuilder.$endpoint}/upload/${id}`,
      formData,
    );
  }
}
